'use client';

import classNames from '@crown3/cx';
import { memo, type CSSProperties } from 'react';
import styles from './Tick.module.css';

const cx = classNames.bind(styles);

enum Direction {
  W = 'W',
  E = 'E',
  N = 'N',
  S = 'S',
}

const DIRECTIONS = [Direction.W, Direction.N, Direction.E, Direction.S];
const INTERCARDINALS = ['NW', 'NE', 'SE', 'SW'];

interface TickProps {
  index: number;
  active: boolean;
  ticksPerTurn: number;
}

export const Tick = memo(function Tick({
  index,
  active,
  ticksPerTurn,
}: TickProps) {
  const ticksPerDirection = ticksPerTurn / DIRECTIONS.length;
  const turnIndex = ((index % ticksPerTurn) + ticksPerTurn) % ticksPerTurn;
  const cardinal =
    turnIndex % ticksPerDirection === 0
      ? DIRECTIONS[turnIndex / ticksPerDirection]
      : undefined;
  const intercardinal =
    turnIndex % ticksPerDirection === ticksPerDirection / 2
      ? INTERCARDINALS[Math.floor(turnIndex / ticksPerDirection)]
      : undefined;

  return (
    <div
      className={cx(['tick', { active, cardinal, intercardinal }])}
      style={{ '--index': index } as CSSProperties}
    >
      <div className={styles.tickLabel}>{cardinal ?? intercardinal}</div>
      <div className={styles.tickIndicator} />
    </div>
  );
});
